import React, { useEffect, useState } from "react";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Route, useHistory } from "react-router-dom";

import { useToken } from "../App/useToken";
import { LoginService } from "../devlogin/LoginService";

import { IssuanceService } from "../CBtabmenu/CBHome/IssuanceService";

export default function Enableassets({ setToken }) {
  const Entityinfo = {
    email: "",
    username: "",
    urlname: "",
    role: "",
    organization: "",
    accountid: "",
    entityaccountnumber: "",
    centralaccountnumber: "",
    entityemail: "",
    entityname: "",
    systemid: "",
    issuerid: "",
    funderid: "",
    entityid: "",
    marker: "",
  };

  const Sendinfo = {
    systemid: "",
    toaccountnumber: "",
    symbol: "",
    amount: "",
  };

  const [email, setEmail] = useState();
  const [password, setPassword] = useState();

  const [sendinfo, setSendinfo] = useState(Sendinfo);
  const [entityinfo, setEntityinfo] = useState(Entityinfo);

  const [error, setError] = useState("");
  const [contracttxid, setContracttxid] = useState("");
  const [tokenissuetxid, setTokenissuetxid] = useState("");
  const [symbol, setSymbol] = useState("");
  const [newsymbol, setNewsymbol] = useState("");
  const [amount, setAmount] = useState(10000);

  const [role, setRole] = useState("");
  const [decimal, setDecimal] = useState(1);
  const [retaillimit, setRetaillimit] = useState(1000);
  const [assets, setAssets] = useState();
  const [totalassets, setTotalassets] = useState(0);

  const loginservice = new LoginService();

  const history = useHistory();

  const roles = ["Central bank", "Wholesale bank", "Exchange"];
  const decimals = [0, 1, 2];

  const issuanceservice = new IssuanceService();
  const usetoken = new useToken();

  useEffect(() => {
    var user = usetoken.getUser();
    setEntityinfo(user);
    getassets1();
  }, []); //

  useEffect(() => {
    gotoproperrole();
  }, [entityinfo.role]); //

  const gotoproperrole = async () => {
    if (entityinfo.role == "Wholesale bank") {
      alert("Logged in as Wholesale bank, going to Wholesale bank admin");
      history.push("/wholesale-bank-one/cbdc-admin");
    }
  };

  const getdata1 = async () => {
    const tokendata = await loginservice.getlatestuser();
    if (tokendata.token) {
      usetoken.saveToken(tokendata);
      setEntityinfo(tokendata.user);
    }
  };

  const getassets1 = async () => {
    var assets = await issuanceservice.getassets();

    var yy = assets.map((kk) => {
      var { disabled, ...newResponse } = kk;
      newResponse.disable = kk.disabled;
      return newResponse;
    });
    console.log(yy.length);
    setTotalassets(yy.length);
    setAssets(yy);
  };

  const enteramount = async (amt) => {
    if (amt > 10000) amt = 10000;
    setAmount(amt);
  };

  const enterretaillimit = async (amt) => {
    if (amt > 5000) amt = 5000;
    setRetaillimit(amt);
  };

  const disableasset = async () => {
    try {
      var data = {
        asset: symbol,
      };
      const tokendata = await loginservice.disableasset(data);
      getassets1();
      setError("Success ");
    } catch (err) {
      //      setError("Update failed " + err);
    }
  };

  const enableasset = async () => {
    try {
      var data = {
        asset: symbol,
      };
      const tokendata = await loginservice.enableasset(data);
      getassets1();
      setError("Success ");
    } catch (err) {
      //     setError("Update failed " + err);
    }
  };

  const fixasset = async () => {
    try {
      var data = {
        symbol: symbol.issuetype,
        retaillimit: symbol.retaillimit,
        decimal: symbol.fraction,
        supply: symbol.amount,
      };
      const tokendata = await loginservice.createasset(data);
      setError("Success ");
    } catch (err) {
      setError("Update failed " + err);
    }
  };

  const contractfixasset = async () => {
    try {
      var data = {
        contracttxid: contracttxid,
        tokenissuetxid: tokenissuetxid,
        symbol: symbol.issuetype,
        retaillimit: symbol.retaillimit,
        decimal: symbol.fraction,
        supply: symbol.amount,
      };
      const tokendata = await loginservice.createasset(data);
      setError("Success ");
    } catch (err) {
      setError("Update failed " + err);
    }
  };

  return (
    <div className="col-12 ">
      <div className="card p-fluid">
        <h5 className="text-3xl text-center uppercase my-3">
          Enable/Disable Assets
        </h5>
        <div className="field text-2xl mt-5 ml-2">
          Logged user:{" "}
          <span className="text-cyan-200">
            {entityinfo ? entityinfo.email : "Not logged in"}
          </span>
        </div>
        <div className="field text-2xl ml-2">
          <label>
            Organization:{" "}
            <span className="text-cyan-200">
              {entityinfo ? entityinfo.organization : "NA"}
            </span>
          </label>
        </div>

        <div className="field text-2xl">
          <label className="ml-2" htmlFor="assets">
            Assets
          </label>

          <Dropdown
            value={symbol}
            options={assets}
            optionLabel="issuetype"
            onChange={(e) => setSymbol(e.target.value)}
            placeholder="Select a Asset"
            id="assets"
            className="p-2 font-semibold  bg-gray-100"
          />
        </div>

        <div className="field text-2xl ml-2">
          <p>
            Total assets : <span className="text-cyan-200"> {totalassets}</span>
          </p>
          <p>
            Asset : <span className="text-cyan-200">{symbol.issuetype}</span>
          </p>
          <p>
            Disabled : <span className="text-cyan-200">{symbol.disable}</span>
          </p>
        </div>

        <div className="field text-2xl">
          {/* Status: */}
          <span className="text-pink-500">{error}</span>
          <div className="grid md:flex align-items-center md:justify-content-between">
            {/* <label> */}
            <Button
              label="Enable asset"
              onClick={() => enableasset()}
              className="col-12 md:col m-3 text-2xl p-button-success"
            />
            <Button
              label="Disable asset"
              onClick={() => disableasset()}
              className="col-12 md:col m-3 text-2xl p-button-danger"
            />
            <Button
              label="Fix issue with  asset"
              onClick={() => fixasset()}
              className="col-12 md:col m-3 text-2xl p-button-secondary"
              disabled={!symbol.issuetype}
            />
            {/* </label> */}
          </div>
        </div>

        <div className="field text-2xl">
          <label htmlFor="contracttxid">Contracttxid </label>

          <InputText
            id="contracttxid"
            type="text"
            placeholder="Contract txid"
            onChange={(e) => setContracttxid(e.target.value)}
            style={{ height: "4rem", fontSize: "2.0rem" }}
          />
        </div>

        <div className="field text-2xl">
          <label htmlFor="tokenissuetxid">Tokenissuetxid </label>

          <InputText
            id="tokenissuetxid"
            type="text"
            placeholder="tokenissuetxid txid"
            onChange={(e) => setTokenissuetxid(e.target.value)}
            style={{ height: "4rem", fontSize: "2.0rem" }}
          />
        </div>

        <div className="field text-2xl">
          <div className="flex  align-items-center  justify-content-between">
            {/* <label> */}
            <Button
              label="Fix txid of  asset"
              onClick={() => contractfixasset()}
              className=" m-3 text-2xl"
              disabled={contracttxid == "" || tokenissuetxid == ""}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
